import { HttpClient } from '@wix/sdk-types';
import {
  SendBiEventOptions,
  sendBiEvent as universalSendBiEvent,
} from './devcenter-bi-events-v1-send-bi-event-response-bi-events.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/app-management' };

export function sendBiEvent(httpClient: HttpClient): SendBiEventSignature {
  return (options?: SendBiEventOptions) =>
    universalSendBiEvent(
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface SendBiEventSignature {
  /**
   * Submit a BI event to Wix.
   */
  (options?: SendBiEventOptions): Promise<void>;
}

export {
  EventName,
  SendBIEventRequest,
  SendBIEventResponse,
  SendBiEventOptions,
} from './devcenter-bi-events-v1-send-bi-event-response-bi-events.universal.js';
